import { LoaderRow } from "@circle-react-shared/LoaderRow";
import { POLL_FORM_ID } from "@circle-react-shared/uikit/TipTapBlockEditor/PollExtension/PollModal/types";
import type { RefObject } from "react";
import type { UseFormReturn } from "react-hook-form";
import { FormProvider } from "react-hook-form";
import { useHotkeys } from "react-hotkeys-hook";

import type { PollFormValues } from "./getPollDefaultValues";
import { PollFields } from "./PollFields";

interface PollFormProps {
  canEditOptions: boolean;
  initialFocusRef?: RefObject<HTMLInputElement | null>;
  isLoading: boolean;
  methods: UseFormReturn<PollFormValues>;
  onSubmit: (values: PollFormValues) => void;
}

export const PollForm = ({
  canEditOptions,
  initialFocusRef,
  isLoading,
  methods,
  onSubmit,
}: PollFormProps) => {
  useHotkeys("mod+enter", event => {
    event.preventDefault();
    event.stopPropagation();
  });

  if (isLoading) {
    return <LoaderRow />;
  }

  return (
    <FormProvider {...methods}>
      <form
        id={POLL_FORM_ID}
        className="flex flex-col gap-6 mb-0"
        onSubmit={event => {
          event.stopPropagation();
          void methods.handleSubmit(onSubmit)(event);
        }}
      >
        <PollFields
          canEditOptions={canEditOptions}
          initialFocusRef={initialFocusRef as RefObject<HTMLInputElement>}
        />
      </form>
    </FormProvider>
  );
};
